import { render, staticRenderFns } from "./TextAndSmallImage.vue?vue&type=template&id=52faf766&scoped=true&"
import script from "./TextAndSmallImage.vue?vue&type=script&lang=js&"
export * from "./TextAndSmallImage.vue?vue&type=script&lang=js&"
import style0 from "./TextAndSmallImage.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./TextAndSmallImage.vue?vue&type=style&index=1&id=52faf766&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52faf766",
  null
  
)

export default component.exports